<template>
  <v-container grid-list-xl fluid>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-title>
            <search-field ref="searchRef" :title="'Search By Card No.'" @search="search"></search-field>
            <v-spacer></v-spacer>
          </v-card-title>

          <v-divider></v-divider>

          <v-container fluid class="pa-2">
            <v-layout row>
              <v-flex sm4 md4></v-flex>
              <v-flex sm8 md8>
                <v-container class="py-2 pr-0" fluid>
                  <v-layout row align-center>
                    <v-flex xs12 sm8 md9 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm10 md11 class="px-0">
                          <p
                            class="text-xs-right grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >Row per Page:</p>
                        </v-flex>
                        <v-flex xs6 sm2 md1 class="text-xs-center">
                          <v-layout row align-center>
                            <v-flex xs7 sm12>
                              <v-select
                                style="font-size: 14px;"
                                :items="page"
                                class="grey--text"
                                id="selected"
                                v-model="pageLimit"
                                @input="limitClick"
                                dense
                                height="20px"
                                :disabled="
                                  this.items.length < 10 ? true : false
                                "
                              ></v-select>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm4 md3 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm6 class="px-0 pl-3">
                          <p
                            class="text-xs-center grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >
                            {{ itemFrom + " -" + itemTo + " of " }}
                            {{ totalItems }}
                          </p>
                        </v-flex>
                        <v-flex xs6 sm6>
                          <v-layout row style="padding-right: 100px;">
                            <v-flex sm6 class="mr-3 pl-0">
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="backClick"
                                :disabled="disabledBack"
                              >
                                <v-icon dark>chevron_left</v-icon>
                              </v-btn>
                            </v-flex>
                            <v-flex sm6>
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="nextClick"
                                :disabled="disabledNext"
                              >
                                <v-icon dark>chevron_right</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <v-data-table :headers="headers" :items="items" hide-actions disable-initial-sort>
            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable', 
                    header.value === queryParams.order ? 'active' : '', 
                    'text-xs-'+header.align
                  ]"
                >
                  <span>{{ header.text }}</span>
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">{{ props.index + queryParams.offset + 1}}</td>
              <td class="text-xs-left text-uppercase no-wrap">{{ props.item.card_no }}</td>
              <td class="text-xs-right text-uppercase no-wrap">{{ props.item.duplicate_count }}</td>
              <td class="text-no-wrap text-xs-center">
                <v-tooltip top>
                  <v-btn icon slot="activator" @click="openViewDialog(props.item)">
                    <v-icon color="blue">find_in_page</v-icon>
                  </v-btn>
                  <span>View Card Status</span>
                </v-tooltip>
                <!-- <edit-button v-if="$moduleAccess('edit')" @edit="openEditDialog(props.item)"></edit-button>
                <delete-button
                  v-if="$moduleAccess('delete')"
                  @delete="openDeleteDialog(props.item)"
                ></delete-button>-->
              </td>
            </template>
          </v-data-table>
          <v-divider></v-divider>
          <v-container class="py-0" fluid>
            <v-layout wrap align-center class="pa-5"></v-layout>
          </v-container>
        </v-card>

        <v-dialog v-model="dialogStatus" width="500">
          <v-card>
            <v-card>
              <v-card-title
                class="title grey lighten-2 font-weight-bold py-3"
                primary-title
              >Card Status</v-card-title>

              <v-card-text>
                <v-card>
                  <v-container fill-height v-if="dialogLoading">
                    <v-layout align-center justify-center>
                      <v-progress-circular :size="40" :width="3" color="primary" indeterminate></v-progress-circular>
                    </v-layout>
                  </v-container>
                  <v-card-text v-else>
                    <span class="font-weight-bold">Card No.:</span>
                    &nbsp;{{ this.viewData.card_no }}
                    <br />
                    <br />
                    <span class="font-weight-bold">Status:</span>
                    &nbsp;{{ this.viewData.status_name }}
                  </v-card-text>
                </v-card>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-2 ma-0" flat @click="closeViewDialog">CLOSE</v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Services from "@/services/Services";
import SearchField from "../components/fields/SearchFieldCardStatus";
import XLSX from "xlsx";
var now = new Date();

export default {
  components: {
    SearchField
  },
  data() {
    return {
      loading: false,
      items: [],
      title: "Card Status",
      headers: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "Card No.",
          align: "left",
          value: "card_no",
          sortable: false
        },
        {
          text: "Duplicate Count",
          align: "right",
          value: "duplicate_count",
          sortable: false
        },
        {
          text: "Actions",
          align: "center",
          sortable: false
        }
      ],
      page: [
        { text: 10, value: 10 },
        { text: 20, value: 20 },
        { text: 30, value: 30 },
        { text: 40, value: 40 },
        { text: 50, value: 50 },
        { text: 60, value: 60 },
        { text: 70, value: 70 },
        { text: 80, value: 80 },
        { text: 90, value: 90 },
        { text: 100, value: 100 }
      ],
      queryParams: {
        limit: 10,
        offset: 0
      },
      totalItems: 0,
      itemFrom: 0,
      itemTo: 0,
      disabledNext: false,
      disabledBack: true,
      disabledLimit: true,
      limit: 10,
      offset: 0,
      dialogStatus: false,
      dialogLoading: false,
      viewData: {}
    };
  },
  created: function() {
    this.getData();
  },
  computed: {
    pageLimit: {
      get() {
        return 10;
      },
      set(val) {
        this.queryParams.limit = val;
        this.queryParams.offset = 0;
      }
    }
  },
  watch: {
    limit: function() {
      this.queryParams.limit = this.limit;
      this.queryParams.offset = 0;
      this.getData();
    }
  },
  methods: {
    search(data) {
      this.queryParams.card_no = data;
      this.getData();
    },
    async getData() {
      // Start Loading
      this.items = [];
      this.$store.dispatch("startLoading");
      try {
        // Query Data
        let response = (await Services.getCardNumbers(this.queryParams)).data;

        // Assign the reponse data to items to be display on table
        this.items = response.data;

        // Assign Total number of data
        this.totalItems = response.count;

        // Assign Number started the data
        this.itemFrom = this.totalItems > 0 ? this.queryParams.offset + 1 : 0;

        // Assign Number end the data
        // this.itemTo = this.queryParams.offset + this.queryParams.limit;

        this.itemTo = this.queryParams.limit;

        if (this.totalItems <= this.itemTo) {
          this.itemTo = this.totalItems;
        }

        // Conditions for NextPage Button
        if (this.itemTo === this.totalItems) {
          this.disabledNext = true;
        } else {
          this.disabledNext = false;
        }
        // Conditions for BackPage Button
        if (this.itemFrom > 1) {
          this.disabledBack = false;
        } else {
          this.disabledBack = true;
        }

        if (this.totalItems <= this.queryParams.limit) {
          this.disabledLimit = true;
        } else {
          this.disabledLimit = false;
        }
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection"
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          } else {
            this.$infoBar({
              type: "error",
              text: "No network or server connection"
            });
          }
        }
      }
      this.$store.dispatch("endLoading");
    },
    limitClick() {
      this.queryParams.offset = 0;
      this.getData();
    },
    nextClick() {
      this.queryParams.offset += this.queryParams.limit;
      this.queryParams.limit += this.queryParams.offset;
      this.getData();
    },
    backClick() {
      this.queryParams.limit -= this.queryParams.offset;
      this.queryParams.offset -= this.queryParams.limit;
      this.getData();
    },
    async openViewDialog(data) {
      this.dialogLoading = true;

      this.dialogStatus = true;

      this.viewData = await this.setData(data.card_no);

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    closeViewDialog() {
      this.dialogStatus = false;
      this.viewData = {};
    },
    async setData(data) {
      let returnedData = {};
      try {
        const response = await Services.getCardDetails(data);
        returnedData = await response.data.data.card;
        returnedData.card_no = data;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        } else {
          if (error.response.status === 403) {
            this.closeDialog();
            this.$store.dispatch("dispatchUnauthorized", true);
          } else {
            this.$infoBar({
              type: "error",
              text: "No network or server connection"
            });
          }
        }
      }
      return returnedData;
    },
    async downloadExcel() {
      this.$store.dispatch("startLoading");

      this.items = [];

      const response2 = (await Services.getTransactionSync({
        offset: 0,
        transaction_type_id: null,
        date_from: this.dateFrom + " " + this.timeFrom + ":00",
        date_to: this.dateTo + " " + this.timeTo + ":59"
      })).data;

      this.items = response2.data;

      let dataToDownload = [];
      let header = [];

      for (let i = 0; i < this.headers.length; i++) {
        header.push(this.headers[i].text);
      }
      header.shift();
      header.pop();
      dataToDownload.push(header);

      for (let e = 0; e < this.items.length; e++) {
        let theItem = [];

        theItem.push(this.items[e].sub_company.code);
        theItem.push(
          this.items[e].card_shift_sync === null
            ? ""
            : this.items[e].card_shift_sync.control_no
        );
        theItem.push(this.items[e].device.device_serial);
        theItem.push(this.items[e].terminal.name.toUpperCase());
        theItem.push(
          this.$dateFormat(this.items[e].transaction_date, "YYYY-MM-DD")
        );
        theItem.push(this.$dateFormat(this.items[e].transaction_date, "HH:mm"));
        theItem.push(this.items[e].transaction_no);
        theItem.push(this.items[e].trace_no);
        theItem.push(this.items[e].card_no);
        theItem.push(this.items[e].transaction_type.name.toUpperCase());
        theItem.push(this.items[e].previous_balance);
        theItem.push(this.items[e].card_amount);
        theItem.push(this.items[e].remaining_balance);
        theItem.push(
          (this.items[e].user.first_name === undefined ||
          this.items[e].user.first_name === null
            ? ""
            : this.items[e].user.first_name) +
            " " +
            (this.items[e].user.middle_name === undefined ||
            this.items[e].user.middle_name === null
              ? ""
              : this.items[e].user.middle_name) +
            " " +
            (this.items[e].user.last_name === undefined ||
            this.items[e].user.last_name === null
              ? ""
              : this.items[e].user.last_name)
        );

        dataToDownload.push(theItem);
      }

      this.$store.dispatch("endLoading");

      // don't delete any codes after this comment got it?!

      var wscols = [
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 } // "pixels"
      ];

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      // var wsname = "SheetJS";

      var fmt = "#,##0";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }
      // wb.SheetNames.push(wsname);
      // wb.Sheets[wsname] = ws;
      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports"
      };

      // ws["!protect"] = {
      //   password: "Journeytech@1",
      //   formatRows: false,
      //   formatColumns: false,
      //   objects: true,
      //   scenarios: true
      // };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"]
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf"
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    }
  }
};
</script>

<style scoped>
</style>
